import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap';
import { ArrayHelper } from 'src/app/models/helpers/array-helper';
import { PlantingSiteSpeciesDto } from 'src/app/models/trofaco/plantingSiteSpeciesDto';
import { speciesDto } from 'src/app/models/trofaco/speciesDto';
import { ApplicationConfigService } from '../../core/services/application-config.service';
import { TreeSpeciesService } from '../../core/services/tree-species.service';
import { ModalAddTreeSpeciesComponent } from './modals/add-tree-species.component';

type getColumnValue = (specie: speciesDto) => number | string | undefined;
type Column = { property: getColumnValue, title: string, textRight?: boolean, canSort?: boolean };

@Component({
  selector: 'app-tree-species',
  templateUrl: './tree-species.component.html',
  styleUrls: ['./tree-species.component.scss']
})

export class TreeSpeciesComponent implements OnInit {
  @ViewChild('deleteModal', { static: false }) deleteModal: ModalDirective;
  speciesDto$: speciesDto[];
  species: speciesDto[];
  filteredSpecies: speciesDto[];
  pageSpecies: speciesDto[];
  plantingSiteList: string;
  treeSpecies: PlantingSiteSpeciesDto = {};
  currentSpecieId: string;
  searchText?: string;

  columns: Column[] = [
      {title: 'Species Name', property: c => c.species, canSort: true},
      {title: 'Description', property: c => c.description},
      {title: 'Image', property: c => c.photoUrl}
  ];
  ModalType = {
    add: 'add',
    edit: 'edit'
  }

  public copied = false;
  modalRef: BsModalRef;
  scrollConfig = {
      suppressScrollX: false, 
      suppressScrollY: true
  };
  sortColumn = this.columns[0];
  sortAsc = true;
  pageSize: number;
  page = 1;

  constructor(
    private treeSpeciesService: TreeSpeciesService,
    private _modalService: BsModalService,
    private route: ActivatedRoute, 
    private router: Router, 
    private appConfigService: ApplicationConfigService
  ) { }

  ngOnInit() {
    this.pageSize = this.appConfigService.treeSpecieListPageSize;
    this.route.data.subscribe(data => {
        this.species = data.species || [];
        this.filterUpdated();
    });
    
    this.router.events.subscribe((evt) => {
        if (!(evt instanceof NavigationEnd)) {
            return;
        }
        window.scrollTo(0, 0);
    });
  }

  filterUpdated() {
      let searchText = this.searchText ? this.searchText.toLowerCase() : '';
      this.filteredSpecies = this.species.filter(species => {
          if (searchText === '') return true;
          return (species.species && species.species.toLowerCase().includes(searchText));
      });
      this.sort();
  }

  sort(column?: Column) {
      if (column && !column.canSort) return;

      if (column === this.sortColumn)
          this.sortAsc = !this.sortAsc;

      if (column)
          this.sortColumn = column;
      this.filteredSpecies = ArrayHelper.sortBy(this.filteredSpecies, this.sortAsc, this.sortColumn.property);
      this.pageChange(this.page);
  }

  pageChange(page: number) {
      this.page = page;
      let start = this.pageSize * (page - 1);
      let end = this.pageSize * page;
      this.pageSpecies = this.filteredSpecies.slice(start, end);
  }

  async updatePageSize(){
      await this.appConfigService.updateSpeciePageSize(this.pageSize);
      setTimeout(() => {
          this.page = 1;
          this.pageChange(this.page);
          this.filterUpdated();
      });
  }

  openEditModal(type: string, specie?: any) {
    this.treeSpecies = type == this.ModalType.edit? {...specie} : {};
    const initialState = {
        speciesDto : this.speciesDto$,
        isEditSpecies : type == this.ModalType.edit,
        treeSpecies: this.treeSpecies,
    };

    this.modalRef = this._modalService.show(ModalAddTreeSpeciesComponent, {
      class: "modal-lg",
      initialState,
      keyboard: false,
    });

    this.modalRef.content.isSaved$.subscribe(async (value) => {
      if (value) {
        this.species = await this.treeSpeciesService.getAllSpecies();
        this.filterUpdated();
      }
    });
  }

  async openDeleteModal(specieId: string) {
    this.currentSpecieId = specieId;
    this.plantingSiteList = await this.treeSpeciesService.getPlantingSiteSpecies(this.currentSpecieId)
    this.deleteModal.show();
  }

  async confirmDelete() {
    await this.treeSpeciesService.deleteSpecies(this.currentSpecieId).then(async res => {
      this.deleteModal.hide();
      this.species = await this.treeSpeciesService.getAllSpecies();
      this.filterUpdated();
    });
  }
  
  config = {
    suppressScrollX: false, suppressScrollY: true
  };

  copyInputMessage(inputElement) {
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);

    this.copied = true;
    //wait 3 Seconds and hide copied
    setTimeout(function () {
      this.copied = false;
    }.bind(this), 3000);
  }

}
